<template>
  <div class="w-100 my-5">
    <v-btn class="mx-5 button-normal" @click="generateTestQRCode">
    <span>Generate Test QR Code</span>
    </v-btn>
    <div class="my-10 w-350px d-flex flex-column" v-if="qrCode">
      <div id="qrCode" class="mx-auto box-white d-flex flex-column" v-if="qrCode">
        <span class="mx-auto mt-5 font-bold font-25">{{ qrCodeNumber }}</span>
        <VueQrcode
          id="qrCode"
          :value="qrCode"
          :options="qrOptions"
          level="H"
        />
      </div>
      <div class="my-5 d-flex justify-content-end">
        <v-btn class="mx-5 button-normal" @click="downloadQRCode">
          <span>Download QR Code</span>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { getDecimalFormat, getDateStringFromTimestamp, showLoading } from '../../../functions';

import VueQrcode from '@chenfengyuan/vue-qrcode';
import html2canvas from 'html2canvas';

export default {
  name: 'SetHandlingFee',
  components: {
    VueQrcode,
  },
  computed: {
    isMobile() {
      return this.$store.state.isMobile;
    },
    statsMap() {
      return this.$store.state.statsMap;
    }
  },
  data() {
    return {
      qrOptions: {
        width: 280,
        color: {
          dark: '#170223',
          light: '#FFFFFF',
        },
      },
      qrCode: '',
      qrCodeNumber: '',
    }
  },
  methods: {
    getDecimalFormat,
    getDateStringFromTimestamp,
    generateTestQRCode() {
      this.qrCodeNumber = (Math.floor(Math.random() * 90_000_000) + 10_000_000).toString();
      this.qrCode = `eventbox-wristband-only-for-test-${this.qrCodeNumber}`;
    },
    downloadQRCode() {
      if (!this.qrCode) {
        this.$toast.error('Unexpected error occurs.');
        return;
      }
      const loader = showLoading(this, 1);
      const options = {
        type: 'dataURL',
      };
      html2canvas(document.getElementById('qrCode'), options).then((canvas) => {
        const link = document.createElement('a');
        const fileName = `${this.qrCode}.jpg`;
        link.setAttribute('download', fileName);
        link.setAttribute('href', canvas.toDataURL('image/jpg').replace('image/jpg', 'image/octet-stream'));
        link.click();
        loader.hide();
      });
    }
  }
};
</script>